export default __webpack_public_path__ + "static/media/num-8.24c32d3f.png";